import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { formatKilos } from '@/lib/utils'
import type { KilosByClient } from '@/types'

interface Props {
  data: KilosByClient[] | undefined
  isLoading: boolean
}

export function TopClientsChart({ data, isLoading }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm font-medium">Top 10 clientes por kg gestionados</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-md bg-gray-100" />
        ) : (
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={data ?? []} layout="vertical" margin={{ left: 8, right: 16 }}>
              <XAxis
                type="number"
                tickFormatter={(v) => formatKilos(v)}
                tick={{ fontSize: 11 }}
              />
              <YAxis
                type="category"
                dataKey="client_name"
                width={110}
                tick={{ fontSize: 11 }}
              />
              <Tooltip formatter={(v) => [formatKilos(v as number), 'kg']} />
              <Bar dataKey="kg" radius={[0, 4, 4, 0]}>
                {(data ?? []).map((_, i) => (
                  <Cell key={i} fill="#7c8c43" />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  )
}
